<style lang="scss">
.panel-main {
    margin-bottom: 15px;
    border: 1px solid #d84a38;
    h3 {
        line-height: 40px;
        background-color: #d84a38;
        color: #fff;
        padding: 0 15px;
    }
    article {
        overflow: hidden;
        line-height: 2.6;
        color: #333;
        padding: 15px;
    }
    .panel-icon {
        float: left;
        border: 1px solid #ccc;
        margin-right: 15px;
    }
    .panel-title {
        font-size: 23px;
        color: #428bca;
    }
}
</style>



<template>
	<div class="panel">
		<Bread v-bind="bread" />
		<Info />
         <Ship />
		 <Boss v-if="!isQilinYun" />
		 <Erp />
		 <Fbb />
	</div>
</template>


<script>
import Bread from '@/components/bread';
import Info from './info';
import Boss from './boss';
import Fbb from './fbb';
import Erp from './erp';
import Ship from './ship';
import utils from '@/utils/index';
export default {
	components: {
		Bread,
		Info,
		Boss,
		Fbb,
		Erp,
        Ship
	},
    data () {
        return {
            // 麒麟云不展示boss系统
            isQilinYun: utils.getIsQilinYunHost(location.host)
        }
    },
	computed: {
		bread() {
			let data = {};
			switch (this.lang) {
				case 'en':
					data = {
						title: 'Dashboard',
						home: 'Main Panel ',
					};
					break;
				default:
					data = {
						title: this.$t('port.profile.main_panel',{defaultValue: "主面板"}),
                        home: this.$t('port.profile.main_panel',{defaultValue: "主面板"}),
					};
					break;
			}
			return data;
		},
	},
};
</script>
